import React from "react";
import { Layout } from "./Layout";
import { payToLocaleString } from "/utils/utils";

// TODO: move isLoading to the parent component
export function Receive({ isLoading, data, currency, ...props }) {
  if (isLoading) {
    return (
      <Layout
        amount={"Loading..."}
        rate={{
          from: "TICO",
          to: currency.code,
          rate: "...",
        }}
        {...props}
      />
    );
  }
  // It's posible to have data without loading if it's initial state
  if (!data || data.type !== "success") {
    return (
      <Layout
        amount={"?"}
        rate={{
          from: "TICO",
          to: currency.code,
          rate: "?",
        }}
        {...props}
      />
    );
  }

  return (
    <Layout
      amount={payToLocaleString(data.response.to.amount)}
      rate={{
        from: data.response.to.code,
        to: data.response.from.code,
        rate: data.response.rate,
      }}
      {...props}
    />
  );
}
